import { cn } from '@/lib/utils';

interface LomooloLogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'dark' | 'light';
  className?: string;
  showText?: boolean;
}

export function LomooloLogo({ size = 'md', variant = 'dark', showText = true, className }: LomooloLogoProps) {
  const sizeMap = {
    sm: { icon: 28, text: 'text-lg', social: 'text-sm', gap: 'gap-2' },
    md: { icon: 36, text: 'text-xl', social: 'text-base', gap: 'gap-2.5' },
    lg: { icon: 44, text: 'text-2xl', social: 'text-lg', gap: 'gap-3' },
  };

  const s = sizeMap[size];
  const textColor = variant === 'light' ? 'text-white' : 'text-[#2D2D2D]';

  return (
    <div className={cn('flex items-center', s.gap, className)}>
      <svg viewBox="0 0 40 40" fill="none" width={s.icon} height={s.icon}>
        <circle cx="20" cy="20" r="20" fill="#F4845F" />
        <circle cx="14" cy="18" r="5" fill="white" />
        <circle cx="26" cy="18" r="5" fill="white" />
      </svg>
      {showText && (
        <>
          <span className={cn('font-[\'Baloo_2\'] font-extrabold tracking-tight', s.text, textColor)}>
            LOM<span className="text-[#F4845F]">OO</span>LO
          </span>
          <span className={cn('font-dm font-semibold text-[#2A9D8F]', s.social)}>Social</span>
        </>
      )}
    </div>
  );
}
